import { render } from "./Mahgoub ceramic gallery.vue?vue&type=template&id=62bba9bc&scoped=true"
const script = {}

import "./Mahgoub ceramic gallery.vue?vue&type=style&index=0&id=62bba9bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62bba9bc"

export default script